module.exports = __webpack_public_path__ + "img/18_19.6904a8f4.png";